export const bootstrapConstants = {
  MEASUREMENT_TYPE_REQUEST: "BOOTSTRAP_MEASUREMENT_TYPE_REQUEST",
  MEASUREMENT_TYPE_SUCCESS: "BOOTSTRAP_MEASUREMENT_TYPE_SUCCESS",
  MEASUREMENT_TYPE_FAILURE: "BOOTSTRAP_MEASUREMENT_TYPE_FAILURE",

  MEASUREMENT_MAGNITUDE_REQUEST: "BOOTSTRAP_MEASUREMENT_MAGNITUDE_REQUEST",
  MEASUREMENT_MAGNITUDE_SUCCESS: "BOOTSTRAP_MEASUREMENT_MAGNITUDE_SUCCESS",
  MEASUREMENT_MAGNITUDE_FAILURE: "BOOTSTRAP_MEASUREMENT_MAGNITUDE_FAILURE",

  MEASUREMENTS_REQUEST: "BOOTSTRAP_MEASUREMENT_REQUEST",
  MEASUREMENTS_SUCCESS: "BOOTSTRAP_MEASUREMENT_SUCCESS",
  MEASUREMENTS_FAILURE: "BOOTSTRAP_MEASUREMENT_FAILURE",

  MEASUREMENT_CATEGORY_REQUEST: "BOOTSTRAP_MEASUREMENT_CATEGORY_REQUEST",
  MEASUREMENT_CATEGORY_SUCCESS: "BOOTSTRAP_MEASUREMENT_CATEGORY_SUCCESS",
  MEASUREMENT_CATEGORY_FAILURE: "BOOTSTRAP_MEASUREMENT_CATEGORY_FAILURE",

  OBJECT_STATUS_REQUEST: "BOOTSTRAP_OBJECT_STATUS_REQUEST",
  OBJECT_STATUS_SUCCESS: "BOOTSTRAP_OBJECT_STATUS_SUCCESS",
  OBJECT_STATUS_FAILURE: "BOOTSTRAP_OBJECT_STATUS_FAILURE",

  DATA_SUCCESS: "USERS_DATA_SUCCESS",
  DATA_FAILURE: "USERS_DATA_FAILURE"
};
